<script setup lang="ts">
import logoUrl from '~/assets/images/logo.svg?url'

defineProps<{
    class?: string
}>()
</script>

<template>
    <img
        :src="logoUrl"
        :alt="$t('YourService')"
        class="h-[30px] w-[71px]"
        :class="$props.class"
    >
</template>
